import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";

import { radius, sectionColors } from "../styles/tokens";
import PageSection from "../sections/PageSection";
import { useSiteTheme } from "../theme/ThemeContext";

export default function CallToActionSection() {
  const navigate = useNavigate();
  const { palette } = useSiteTheme();

  const handleCommissionEnquiry = () => {
    navigate("/contact", {
      state: {
        enquiry: {
          type: "commission",
        },
      },
    });
  };
  return (
    <PageSection
      bg={palette.cta}
      sx={{ pt: { xs: 2, md: 3 }, pb: { xs: 5, md: 6 } }}
    >
      <Box
        sx={{
          borderRadius: radius.surface,
          color: palette.text,
          px: { xs: 3, md: 5 },
          py: { xs: 3, md: 4 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "100%",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "center" },
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Typography
            variant="body1"
            sx={{
              flex: 1,
              fontSize: {
                xs: "1rem",
                md: "1.1rem",
              },
              lineHeight: 1.6,
            }}
          >
            The artist also accepts commissions for new icons in the traditional
            Byzantine style.
          </Typography>

          <Button
            variant="contained"
            size="large"
            sx={{
              flexShrink: 0,
            }}
            onClick={handleCommissionEnquiry}
          >
            Enquire about a Commission
          </Button>
        </Box>
      </Box>
    </PageSection>
  );
}
